// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screening-searches {
  display: block;
  padding: 0.21%;
  background: white;
}
.screening-searches table {
  width: 99%;
}
.screening-searches th {
  font-weight: 600;
  padding: 7px 5px;
  color: #4b58a6;
}
.screening-searches tr {
  border-bottom: 1px solid #e7ebeb;
  margin: 1%;
}
.screening-searches tr td {
  padding: 0.3%;
}
.screening-searches tr.error-state {
  background: #ce6161 !important;
}
.screening-searches tr.canceled-state {
  background: #d88949 !important;
}
.screening-searches tr.voided-state {
  background: #e2b94f !important;
}
.screening-searches tr.invoiced-state {
  background: #A5DC89 !important;
}
.screening-searches tr.paid-state {
  background: #6699CC !important;
}
.screening-searches tr i {
  padding: 0 3.5%;
}
.vendor-id-modal-input {
  font-size: 0.95rem;
  word-break: break-all;
  min-height: 2.75rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/components/screening-searches-table/screening-searches-table.component.less"],"names":[],"mappings":"AAEA;EACI,cAAA;EACA,cAAA;EACA,iBAAA;AADJ;AAFA;EAKQ,UAAA;AAAR;AALA;EAQQ,gBAAA;EACA,gBAAA;EACA,cAAA;AAAR;AAVA;EAaQ,gCAAA;EACA,UAAA;AAAR;AAdA;EAgBY,aAAA;AACZ;AACQ;EACI,8BAAA;AACZ;AACQ;EACI,8BAAA;AACZ;AACQ;EACI,8BAAA;AACZ;AACQ;EACI,8BAAA;AACZ;AACQ;EACI,8BAAA;AACZ;AAhCA;EAkCY,eAAA;AACZ;AAIA;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;AAFJ","sourcesContent":["\n\n.screening-searches{\n    display: block;\n    padding: .21%;\n    background: white;\n    table{\n        width: 99%;     \n    }\n    th{\n        font-weight: 600;\n        padding: 7px 5px;\n        color: #4b58a6;    \n    }\n    tr{\n        border-bottom: 1px solid #e7ebeb;\n        margin: 1%;\n        td{\n            padding:.3%;\n        }\n        &.error-state {\n            background: #ce6161 !important;\n        }\n        &.canceled-state {\n            background: #d88949 !important;\n        }\n        &.voided-state {\n            background: #e2b94f !important;\n        }\n        &.invoiced-state {\n            background: #A5DC89 !important;\n        }\n        &.paid-state {\n            background: #6699CC !important;\n        }\n        i{\n            padding:0 3.5%;\n        }\n    }\n}\n\n.vendor-id-modal-input {\n    font-size: 0.95rem;\n    word-break: break-all;\n    min-height: 2.75rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
